export default __webpack_public_path__ + "static/media/huiyuanguanli_w.ed995ba1.png";